import planitLinkInfoEn from "./locales/en.json";

export const PLANIT_LINK_INFO_NS = "planitLinkInfo";

export const PlanitLinkInfoI18n = {
  en: {
    [PLANIT_LINK_INFO_NS]: {
      ...planitLinkInfoEn,
    },
  },
};
